export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/feature-feedback.4fe28f0e-0dbc7e.png";